/* =============================================================
   INBAR+co — ic-product.js
   Shared product page scripts
   Used by all ic-product-[name].liquid sections
============================================================= */

/* IMAGE GALLERY */
var _icImgIdx = 0;
var _icImgEls = [];
document.addEventListener('DOMContentLoaded', function() {
  _icImgEls = Array.prototype.slice.call(document.querySelectorAll('.ic-p-hero__img-slide'));
  if (!_icImgEls.length) return;
  icShowImage(0);
  if (_icImgEls.length > 1) {
    document.querySelectorAll('.ic-p-hero__chevron').forEach(function(c) { c.style.display = 'flex'; });
  }
});
function icShowImage(idx) {
  _icImgIdx = (idx + _icImgEls.length) % _icImgEls.length;
  _icImgEls.forEach(function(el, i) {
    el.style.display = i === _icImgIdx ? 'block' : 'none';
  });
}
function icNextImage() { icShowImage(_icImgIdx + 1); }
function icPrevImage() { icShowImage(_icImgIdx - 1); }

/* VARIANT SELECTOR — hero pill buttons */
function icSelectVariant(el) {
  /* Don't allow selecting sold-out variants */
  if (el.dataset.available === 'false') return;
  document.querySelectorAll('.ic-p-hero__size-opt').forEach(function(o) { o.classList.add('ghost'); });
  el.classList.remove('ghost');
  var vid   = el.dataset.variantId;
  var price = el.dataset.price;
  var note  = el.dataset.priceNote;
  var avail = el.dataset.available;
  icApplyVariant(vid, price, note, avail);
}

/* VARIANT SELECTOR — sticky select dropdown */
function icSelectVariantFromSelect(selectEl) {
  var opt   = selectEl.options[selectEl.selectedIndex];
  var vid   = opt.value;
  var price = opt.dataset.price;
  var note  = opt.dataset.priceNote;
  var avail = opt.dataset.available;
  document.querySelectorAll('.ic-p-hero__size-opt').forEach(function(o) {
    o.classList.toggle('ghost', o.dataset.variantId !== vid);
  });
  icApplyVariant(vid, price, note, avail);
}

/* Shared: update ATC buttons, prices, price note */
function icApplyVariant(vid, price, note, avail) {
  var isSoldOut = avail === 'false';
  document.querySelectorAll('.ic-btn-atc, .ic-p-sticky__atc').forEach(function(btn) {
    btn.dataset.variantId = vid;
    btn.dataset.available = avail;
    if (isSoldOut) {
      btn.disabled = true;
      btn.classList.add('ic-btn-soldout');
      btn.textContent = 'Sold Out';
    } else {
      btn.disabled = false;
      btn.classList.remove('ic-btn-soldout');
      btn.textContent = btn.dataset.defaultLabel || 'Add to Bag';
    }
  });
  var sel = document.getElementById('ic-sticky-select');
  if (sel) sel.value = vid;
  var priceEl = document.getElementById('ic-price');
  if (priceEl) priceEl.textContent = price;
  var stickyPriceEl = document.getElementById('ic-sticky-price');
  if (stickyPriceEl) stickyPriceEl.textContent = price;
  /* Update price note (e.g. "30 ml / 1 fl oz") */
  if (note) {
    var noteEl = document.getElementById('ic-price-note') || document.querySelector('.ic-p-hero__price-note');
    if (noteEl) noteEl.textContent = note;
  }
}

/* THE BRIEF — mobile collapsible */
(function() {
  var trigger = document.querySelector('.ic-p-editorial__trigger');
  var wrap    = document.querySelector('.ic-p-editorial__body-wrap');
  if (!trigger || !wrap) return;
  trigger.addEventListener('click', function() {
    var isOpen = wrap.classList.contains('open');
    wrap.classList.toggle('open', !isOpen);
    trigger.classList.toggle('open', !isOpen);
  });
})();

/* SCIENCE ACCORDION */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ic-p-science__item').forEach(function(item) {
    item.addEventListener('click', function() {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.ic-p-science__item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
});

/* DETAILS / INGREDIENTS TOGGLE */
document.addEventListener('DOMContentLoaded', function() {
  var ingr = document.querySelector('.ic-p-details__ingr');
  if (ingr) {
    ingr.addEventListener('click', function() {
      ingr.classList.toggle('open');
    });
  }
});

/* PROTOCOL STEP ACCORDION */
function icToggleStep(id) {
  var row = document.getElementById(id);
  if (!row) return;
  var isOpen = row.classList.contains('open');
  document.querySelectorAll('.ic-p-step').forEach(function(r) { r.classList.remove('open'); });
  if (!isOpen) row.classList.add('open');
}

/* SPA TIP ACCORDION */
function icToggleSpa(el) {
  var isOpen = el.classList.contains('open');
  document.querySelectorAll('.ic-p-spa__tip').forEach(function(t) { t.classList.remove('open'); });
  if (!isOpen) el.classList.add('open');
}

/* FAQ TOGGLE */
function icToggleFaq(item) {
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.ic-p-faq-item').forEach(function(i) { i.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
}

/* STICKY BAR — appears when hero CTA scrolls out, hides at also-like section */
(function() {
  var sticky  = document.getElementById('ic-sticky');
  var heroAtc = document.querySelector('.ic-p-hero__ctas');
  var closeEl = document.querySelector('.ic-p-also-like');
  if (!sticky || !heroAtc) return;
  function update() {
    var pastHero     = heroAtc.getBoundingClientRect().bottom < 0;
    var closeVisible = closeEl ? closeEl.getBoundingClientRect().top < window.innerHeight : false;
    sticky.classList.toggle('ic-sticky--visible', pastHero && !closeVisible);
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

/* ADD TO CART — Shopify AJAX Cart API */
function icAddToCart(btn) {
  /* Guard: refuse to add if the button is disabled or its variant is unavailable */
  if (btn.disabled || btn.dataset.available === 'false') return;
  var heroBtn   = document.getElementById('ic-hero-atc');
  var variantId = (heroBtn && heroBtn.dataset.variantId) ? heroBtn.dataset.variantId : btn.dataset.variantId;
  if (btn.classList.contains('ic-p-step__atc-btn') || btn.classList.contains('ic-p-step__cta')) {
    variantId = btn.dataset.variantId;
  }
  /* Card-shaped ATC buttons (e.g. .ic-p-also-card--atc) carry their own variant id —
     never inherit from the hero. */
  if (btn.classList.contains('ic-p-also-card')) {
    variantId = btn.dataset.variantId;
  }
  /* Secondary guard: if the hero is the source-of-truth, also respect its availability */
  if (heroBtn && heroBtn.dataset.available === 'false' && !btn.classList.contains('ic-p-step__atc-btn') && !btn.classList.contains('ic-p-step__cta') && !btn.classList.contains('ic-p-also-card')) {
    return;
  }
  if (!variantId || variantId === '') {
    console.warn('INBAR+co: No Variant ID. Set via theme customizer.');
    return;
  }
  /* Card-shaped buttons contain image + body + footer divs. Writing textContent on
     the button itself would wipe the layout. Target the inner label span when present;
     fall back to the button itself for simple text-only ATC buttons. */
  var label = btn.querySelector('.ic-p-also-card__cta') || btn;
  var orig = label.textContent;
  label.textContent = 'Adding...';
  btn.disabled = true;
  btn.style.opacity = '0.6';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
  .then(function(r) { if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Cart error'); }); return r.json(); })
  .then(function() {
    label.textContent = 'Added';
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:open',    { bubbles: true }));
    if (window.Shopify && window.Shopify.sections) window.Shopify.sections.load('cart-drawer');
    setTimeout(function() { label.textContent = orig; btn.style.opacity = ''; btn.disabled = false; }, 2200);
  })
  .catch(function(err) {
    console.error('INBAR+co cart error:', err.message);
    label.textContent = 'Try again';
    btn.style.opacity = '';
    btn.disabled = false;
    setTimeout(function() { label.textContent = orig; }, 2200);
  });
}
window.icAddToCart = icAddToCart;

/* ADD-ON CHECKBOX — Aluminium Atomiser / WWF */
function icToggleAddon(checkbox) {
  var variantId = checkbox.dataset.variantId;
  if (!variantId || variantId === '') {
    console.warn('INBAR+co: Add-on variant ID not set. Add via theme customizer.');
    checkbox.checked = false;
    return;
  }
  if (checkbox.checked) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) { return r.ok ? r.json() : r.json().then(function(d) { throw new Error(d.description); }); })
    .then(function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function(err) {
      console.error('INBAR+co add-on error:', err.message);
      checkbox.checked = false;
    });
  } else {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function(err) { console.error('INBAR+co add-on remove error:', err.message); });
  }
}
window.icToggleAddon = icToggleAddon;
